import React, {useEffect, useState} from "react";

import firebase from "./Config";

import Contact from "./contact";
const Main = () => {
  
   
    const [posts, setPosts] = useState([]);
    
    const getPosts = async() => {
        let _posts = [];
        const postsArray = await firebase.getPosts().catch( err => {
            console.log(err);
        });

        postsArray.forEach(doc => {
           _posts.push({id: doc.id, data: doc.data()});
        });
        setPosts(_posts);
    }


    useEffect(() => {
        getPosts();
    }, []);


    return(
 <React.Fragment>
 
 <body class="s-it" data-spy="scroll" data-target=".it-up-main-navigation" data-offset="80" data-new-gr-c-s-check-loaded="14.1027.0" data-gr-ext-installed="" >
 <div class="up">
		<a href="#" class="scrollup text-center" style={{display: "none"}}>
      <i class="fas fa-chevron-up"></i></a>
	</div>
 <header id="it-header-up" class="it-header-up-seaction">
		<div class="it-header-up-top clearfix"> 
			<div class="container">
				<div class="it-header-top-cta float-left">
					<a href="#"><i class="fas fa-envelope"></i>Muhammadkamranntu@gmail.com</a>
					<a href="#"><i class="fas fa-phone"></i>041-8756072,+923004511610,+92317782979</a>
					
				</div>
			
			</div>
		</div>
		<div class="it-up-header-main" style={{height:"100px"}}>
			<div class="container">
				<div class="it-up-brand-logo float-left">
					<a href="/" >
            <img src="dev.png" style={{height:"57px"}} alt=""/>
			</a>
				</div>
				<div class="it-up-main-menu-wrap clearfix">
					<nav class="it-up-main-navigation float-left ul-li">
						<ul id="main-nav" class="navbar-nav text-capitalize clearfix">
							<li><a class="nav-link active" href="/">Home</a></li>
							<li><a class="nav-link" href="#about">About</a></li>
				
							<li><a class="nav-link" href="#skill">Skills</a></li>
						
							<li><a class="nav-link" href="#portfolio">Portfolio</a></li>
						</ul>
					</nav>
					<div class="it-up-header-cta-btn float-right text-center">
						<a href="#contact">Hire me</a>
					</div>
				</div>
				<div class="mobile_menu relative-position">
					<div class="mobile_menu_button it-up-open_mobile_menu">
						<i class="fas fa-bars"></i>
					</div>
					<div class="it-up-mobile_menu_wrap">
						<div class="mobile_menu_overlay it-up-open_mobile_menu"></div>
						<div class="mobile_menu_content">
							<div class="mobile_menu_close it-up-open_mobile_menu">
								<i class="far fa-times-circle"></i>
							</div>
							
							<nav class="main-navigation mobile_menu-dropdown  clearfix ul-li">
								<ul id="main-nav" class="navbar-nav text-capitalize clearfix">
								<li><a class="nav-link active" href="/">Home</a></li>
							<li><a class="nav-link" href="#about">About</a></li>
							<li><a class="nav-link" href="#services">Service</a></li>
							<li><a class="nav-link" href="#skill">Skills</a></li>
							
							<li><a class="nav-link" href="#portfolio">Portfolio</a></li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
 
  <section id="it-up-banner" class="it-up-banner-section position-relative">
		<span class="it-up-banner-deco1 position-absolute">
    <img src="b-vector1.png" alt=""/></span>
		<span class="it-up-banner-deco2 position-absolute">
       <img src="b-shape1.png" alt=""/></span>
		<span class="it-up-banner-deco3 position-absolute"> 
    <img src="b-shape2.png" alt=""/></span>
		<span class="it-up-banner-deco4 position-absolute"> 
    <img src="b-shape3.png" alt=""/></span>
		<div class="container" id="about">
			<div class="it-up-banner-content position-relative">
				<div class="it-up-banner-text headline-1 pera-content">
					<span>I AM Muhammad Kamran</span>
					<h1>A MERN Stack Developer 
					</h1>
					<p>A MERN Stack developer having experience in Nodejs, Express Js,React js,MongoDB,Firebase,Redux, PHP Laravel, MERN Stack,FERN Stack.</p>
					<div class="it-up-banner-btn d-flex">
						<div class="it-up-banner-play-btn text-center">
							<a class="video_box" href="#"><i class="fas fa-play"></i></a>
						</div>
						<div class="it-up-banner-cta-btn text-center">
							<a href="#contact">Hire me <i class="fas fa-arrow-right"></i></a>
						</div>
					</div>
				</div>
				<div class="it-up-banner-img">
					<img src="https://firebasestorage.googleapis.com/v0/b/muhammadkamranlive.appspot.com/o/l.PNG?alt=media&token=686b161f-8cc6-4e86-bd28-b958f51e95d3" alt=""/>
					<span class="it-up-img-deco1 position-absolute" data-parallax="{&quot;x&quot; : -70}" style={{transform:"translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1); -webkit-transform:translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1); "}}> 
          <img src="slack.png" alt=""
          />
          </span>
					<span class="it-up-img-deco2 position-absolute" data-parallax="{&quot;y&quot; : -70}" style={{transform:"translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1); -webkit-transform:translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1); "}}> 
          <img src="dimond.png" alt=""/>
          </span>
					<span class="it-up-img-deco3 position-absolute" data-parallax="{&quot;y&quot; : 70}" style={{transform:"translate3d(0px, 0.029px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1); -webkit-transform:translate3d(0px, 0.029px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1);"}}> 
          <img src="en.png" alt=""/>
          </span>
				</div>
			</div>
		</div>
	</section>

	
  




  <section id="it-up-service" class="it-up-service-section position-relative">
		<span class="it-up-service-shape position-absolute deco1">
      <img src="s-shape1.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco2">
      <img src="s-shape2.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco3">
      <img src="s-shape3.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco4">
      <img src="s-shape4.png" alt=""/></span>
		<span class="it-up-service-shape position-absolute deco5">
      <img src="s-shape5.png" alt=""/></span>
		<div class="container" id="skill">
			<div class="it-up-section-title headline-1 text-center">
				<span>_Skills?_</span>
				<h2>Tools/Lanuages/Framworks/Platforms</h2>
			</div>
			<div class="it-up-service-content">
				<div class="row">
				
					<div class="col-lg-4 mb-4">
						<div class="it-up-service-tab-content">
							<div id="tabsContent" class="tab-content">
								<div id="marketing" class="tab-pane fade active show">
									<div class="it-up-service-tab-wrap clearfix">
										<div class="it-up-service-tab-text position-relative float-left ul-li-block headline-1">
											<h3>Front-End</h3>
											<ul>
												<li>HTML,CSS,Bootstrap</li>
												<li>CSS Flexbox</li>
												<li>React JS,React Native,Flutter </li>
												<li>JavaScript</li>
												<li>Chrome DevTools</li>
												<li>React Query</li>
												<li>React Redux Toolkit</li>
												<li>react-chartjs-2.js ,Recharts.js</li>
												<li>Figma</li>
											</ul>
											<a class="it-up-ser-btn" href="#contact">Hire me <i class="fas fa-arrow-right"></i></a>
											<span class="it-up-tab-icon position-absolute">
                                           <img src="tab-icon1.png" alt=""/></span>
										</div>
										
									</div>
								</div>
								
							</div>
						</div>
					</div>
				
					<div class="col-lg-4 mb-4">
						<div class="it-up-service-tab-content">
							<div id="tabsContent" class="tab-content">
								<div id="marketing" class="tab-pane fade active show">
									<div class="it-up-service-tab-wrap clearfix">
										<div class="it-up-service-tab-text position-relative float-left ul-li-block headline-1">
											<h3>Back-End</h3>
											<ul>
												<li>Core PHP</li>
												<li>PHP Laravel</li>
												<li>Node js,Express JS</li>
												<li>Firebase Backend</li>
												
											</ul>
											<a class="it-up-ser-btn" href="#contact">Hire me <i class="fas fa-arrow-right"></i></a>
											<span class="it-up-tab-icon position-absolute">
                                           <img src="tab-icon1.png" alt=""/></span>
										</div>
										
									</div>
								</div>
								
							</div>
						</div>
					</div>
					<div class="col-lg-4 ">
						<div class="it-up-service-tab-content">
							<div id="tabsContent" class="tab-content">
								<div id="marketing" class="tab-pane fade active show">
									<div class="it-up-service-tab-wrap clearfix">
										<div class="it-up-service-tab-text position-relative float-left ul-li-block headline-1">
											<h3>Data Bases</h3>
											<ul>
												<li>MongoDB</li>
												<li>Firebase FireStore</li>
												<li>MYSQL</li>
												<li>SQL Server</li>
											</ul>
											<a class="it-up-ser-btn" href="#contact">Hire me <i class="fas fa-arrow-right"></i></a>
											<span class="it-up-tab-icon position-absolute">
                                           <img src="tab-icon1.png" alt=""/></span>
										</div>
										
									</div>
								</div>
								
							</div>
						</div>
					</div>
					
					<div class="col-lg-4">
						<div class="it-up-service-tab-content">
							<div id="tabsContent" class="tab-content">
								<div id="marketing" class="tab-pane fade active show">
									<div class="it-up-service-tab-wrap clearfix">
										<div class="it-up-service-tab-text position-relative float-left ul-li-block headline-1">
											<h3>Payment Gateways</h3>
											<ul>
											<li>Stripe.com</li>
											<li>PayPal</li>
											<li>PayTM</li>
											</ul>
											<a class="it-up-ser-btn" href="#contact">Hire me <i class="fas fa-arrow-right"></i></a>
											<span class="it-up-tab-icon position-absolute">
                                           <img src="tab-icon1.png" alt=""/></span>
										</div>
										
									</div>
								</div>
								
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="it-up-service-tab-content">
							<div id="tabsContent" class="tab-content">
								<div id="marketing" class="tab-pane fade active show">
									<div class="it-up-service-tab-wrap clearfix">
										<div class="it-up-service-tab-text position-relative float-left ul-li-block headline-1">
											<h3>Data Visualization</h3>
											<ul>
											<li>Recharts.js</li>
											<li>Chartjs</li>
											<li>D3.js</li>
											<li>react-chartjs-2.js</li>
											</ul>
											<a class="it-up-ser-btn" href="#contact">Hire me <i class="fas fa-arrow-right"></i></a>
											<span class="it-up-tab-icon position-absolute">
                                           <img src="tab-icon1.png" alt=""/></span>
										</div>
										
									</div>
								</div>
								
							</div>
						</div>
					</div>
				
				</div>
			</div>
		</div>
	</section>

  	




	
 			


	<section id="it-up-blog" class="it-up-blog-section position-relative">
		<span class="it-up-blog-shape-bg1 position-absolute">
			<img src="blg-shape1.png" alt=""/></span>
		<span class="it-up-blog-shape-bg2 position-absolute">
			<img src="blg-shape2.png" alt=""/></span>
		<div class="container"  id="portfolio" >
			<div class="it-up-section-title headline-1 text-center">
				<span>Portfolio</span>
				<h2>My Latest Work </h2>
			</div>
			<div class="it-up-blog-content">
			  
			<div className="container">
					   <div className="row">
					{
						posts.map((list)=>{
							return(
						<div class="col-lg-4 mb-4" >
						<div class="it-up-blog-innerbox it-up-blog-grean">
						<div class="it-up-blog-img">
							<img src={list.data.cover} alt={list.id}/>
						</div>
						<div class="it-up-blog-text position-relative headline-1 pera-content">
							
							<h3><a href="#">{list.data.title}</a></h3>
							<p>{list.data.content}</p>
							<div class="it-up-blog-bottom clearfix">
								<div class="it-up-blog-author float-left">
									<div class="it-up-blog-ath-img float-left">
										<img src="pp.jpg" alt=""/>
									</div>
									<div class="it-up-blog-ath-text text-uppercase">
										<a href="#">By Kamran</a>
									
									</div>
								</div>
							
							</div>
						</div>
					</div>
					</div>
					
					
							)
						})
					}
					
					   
					   
					   </div>
				   </div>
	
			
			</div>
		
		
		</div>
	</section>

	<Contact/>



	<section id="it-up-footer" class="it-up-footer-section position-relative">
		<div class="container">
			<div class="it-up-footer-content-wrap">
				<div class="row">
					<div class="col-lg-3 col-md-6">
						<div class="it-up-footer-widget headline-1 pera-content">
							<div class="it-up-footer-logo-widget it-up-headline pera-content">
								<div class="it-up-footer-logo">
									<a href="#">
										<img src="dev.png" alt="" style={{width:"184px"}}/></a>
								</div>
								
								<a class="footer-logo-btn text-center text-capitalize" href="#contact">Get In Touch <i class="fas fa-arrow-right"></i> </a>
							</div>
						</div>
					</div>
					
					<div class="col-lg-6 col-md-6">
						<div class="it-up-footer-widget headline-1 pera-content">
							<div class="it-up-footer-info-widget ul-li">
								<h3 class="widget-title">Address:</h3>
								<ul>
									<li>
										<i class="fas fa-map-marker-alt"></i> 
										<a href="#">
										Sabina Town 203 RB Manawala Faisalabad.</a>
									</li> <br/>
									
								</ul>
							
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6">
						<div class="it-up-footer-widget headline-1 pera-content">
							<div class="it-up-footer-insta-gram-widget">
								<h3 class="widget-title">Quick Contacts</h3>
								<div class="insta-feed ul-li clearfix">
									<ul>
									<li><a href="#" className="text-white">Phone:+923177682979</a></li>
									<div class="office-open-hour ">
									<span className="text-white">Email: </span>
									< p className="text-white">Muhammadkamranntu@gmail.com
									</p>
									
								</div>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="it-up-footer-copyright text-center pera-content">
			<div class="container">
				<p>© 2021 Muhammad Kamran. All rights reserved.</p>
			</div>
		</div>
	</section>


 </body>

        
        </React.Fragment>
    )
}

export default Main;